@if (entity) {
  <div class="split-view-details">
    <div class="readonly-details">
      <div class="form-section">
        <div class="p-flex-row head-row">
          <div class="logo-and-name">
            <div class="package-logo" [pTooltip]="entity.name" tooltipPosition="left">
              @if (!!logoSrc) {
                <img [src]="logoSrc" onError="this.src = '/assets/img/default.png'"/>
              }
              @if (!logoSrc) {
                <img [src]="'/assets/img/default.png'" onError="this.src = '/assets/img/default.png'"/>
              }
            </div>
            <div class="name-container">
              @if (!modifyingName) {
                <span (click)="nameClicked($event)" [ngClass]="{'hoverable': interactive}" class="packagename" data-testing-id="package_name">{{ entity.name }}</span>
              }
              @if (modifyingName) {
                <div class="name-modify">
                  <div class="packagename">
                    <input #nameInput (keydown.enter)="saveNameModification();" (blur)="(!modifiedName || modifiedName === entity.name) && clearModifyName();" size="36" type="text" pInputText [(ngModel)]="modifiedName">
                  </div>
                  @if (modifiedName && modifiedName != entity.name) {
                    <div class="confirmation-area">
                      @if (!nameModificationInProgress) {
                        <button pButton class="p-button-rounded p-button-text" pTooltip="Save changes" tooltipPosition="top" icon="true" (click)="saveNameModification(); $event.stopPropagation();">
                          <fa-icon icon="save"></fa-icon>
                        </button>
                      }
                      @if (nameModificationInProgress) {
                        <button pButton class="p-button-rounded p-button-text" icon="true">
                          <fa-icon icon="cog" animation="spin"></fa-icon>
                        </button>
                      }
                      <button pButton class="p-button-rounded p-button-text" (click)="clearModifyName(); $event.stopPropagation();" pTooltip="Cancel" tooltipPosition="top" icon="true">
                        <fa-icon icon="times"></fa-icon>
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="creator-and-creationtime">
            <wm-avatar [userId]="entity.creator"></wm-avatar>
            <div title="Creation time of latest version">{{entity.creationTime | wmCalendarFormat }}</div>
          </div>
        </div>
        <div class="p-flex-row">
          <div class="form-item">
            <div>{{entity.description}}</div>
          </div>
        </div>
        <div class="p-flex-column">
          @if (outdatedInstrumentation) {
            <div class="outdated-instrumentation-info">
              <fa-icon [icon]="faInfoCircle"></fa-icon>
              <span>App instrumentation is outdated. Basic usage is unaffected, but selective simulation features in the workbench require a re-upload to automatically re-instrument the app.</span>
            </div>
          }
          <div class="form-item humble">
            <label>App Id:</label>
            <div class="value">
              <div data-testing-id="package_id">{{entity.id}}</div>
            </div>
          </div>
          <div class="form-item humble">
            <label>Platform:</label>
            <div class="value platform-info">
              <div class="platform-logo">
                @if (platformLogoSrc !== undefined) {
                  <img [src]="platformLogoSrc"/>
                }
                @if (!platformLogoSrc) {
                  <p-progressSpinner [style]="{'width': '30px', 'height': '30px'}" strokeWidth="5" class="wm-m-package-loading-spinner"></p-progressSpinner>
                }
              </div>
              <!-- fourth cell: metadata -->
              @if (entity.origMetaData !== undefined) {
                <div class="wm-m-package-metadata wm-list-cell">
                  @if (entity.origMetaData.minSdk !== undefined) {
                    <div class="wm-m-min-version" data-testing-id="min_sdk">Minimum SDK: {{entity.origMetaData.minSdk}}</div>
                  }
                  @if (entity.origMetaData.targetSdkVersion !== undefined) {
                    <div class="wm-m-target-version" data-testing-id="target_sdk">Target SDK: {{entity.origMetaData.targetSdkVersion}}</div>
                  }
                </div>
              }
            </div>
          </div>
          @if (entity.origMetaData.package) {
            <div class="form-item humble">
              <label>App / Bundle Id:</label>
              <div class="value">
                <div data-testing-id="package_bundle_id">{{entity.origMetaData.package}}</div>
              </div>
            </div>
          }
          @if (entity.origMetaData.version) {
            <div class="form-item humble">
              <label>App Version:</label>
              <div class="value">
                <div data-testing-id="package_version">{{entity.origMetaData.version}}</div>
              </div>
            </div>
          }
          <div class="form-item humble">
            <label>Version:</label>
            <div class="value">
              <div data-testing-id="version_number">{{entity.index + 1}}</div>
            </div>
          </div>
        </div>
      </div>
      @if (interactive || entity?.packageSource) {
        <div class="form-section">
          <label>App Source</label>
          @if (entity.packageSource; as pkgSrc) {
            <div class="package-source">
              @if (pkgSrc?.repositoryConfig?.type === 'AppCenterPackageSourceConfig') {
                <div class="appcenter">
                  <div class="repository-info">
                    <div class="repository-logo"><img src="assets/img/appcenter.svg"></div>
                    Microsoft AppCenter
                  </div>
                  <div class="app-info">
                    <div class="owner info-item"><label>Owner</label>{{pkgSrc.repositoryConfig?.owner}}</div>
                    <div class="name info-item"><label>App Name</label>{{pkgSrc.repositoryConfig?.appName}}</div>
                    @if (pkgSrc.repositoryConfig?.wantBuild && pkgSrc.repositoryConfig?.branch) {
                      <div class="branch info-item">
                        <label>Branch</label>{{pkgSrc.repositoryConfig?.branch}}</div>
                      }
                      @if (pkgSrc.repositoryConfig?.branch) {
                        <div class="branch info-item">
                          <label>Trigger</label>{{ pkgSrc.repositoryConfig?.wantBuild ? 'Latest Build' : 'Latest Release' }}
                        </div>
                      }
                    </div>
                    @if (entity?.origProvenanceInfo?.provenanceInfo; as provenance) {
                      <div class="current-build-info">
                        @if (pkgSrc.repositoryConfig?.wantBuild) {
                          <div class="owner info-item">
                            <label>Latest Build</label>(#{{provenance?.id}}) &mdash; {{provenance?.finishTime | wmCalendarFormat}}
                          </div>
                        }
                        @if (!pkgSrc.repositoryConfig?.wantBuild) {
                          <div class="owner info-item">
                            <label>Release</label> {{provenance?.short_version}} ({{provenance?.version}}) &mdash; {{provenance?.uploaded_at | wmDateFormat: 'YYYY-MM-DD HH:mm' }}
                          </div>
                        }
                      </div>
                    }
                    <div class="shifter" style="flex: 1 1 0;"></div>
                    @if (interactive) {
                      <div class="actions">
                        <button pButton class="p-button-text" label="Update to Latest" (click)="updatePackageFromPackageSource(entity.id)">
                          @if (!packageSourceUpdating) {
                            <fa-icon icon="sync-alt"></fa-icon>
                          }
                          @if (packageSourceUpdating) {
                            <fa-icon icon="sync-alt" animation="spin"></fa-icon>
                          }
                        </button>
                        <p-menu wmknbn9697bugfix fontawesomeIcons #packageSourceMenuPopup appendTo="body" [popup]="true" [model]="packageSourceMenuItems"></p-menu>
                        <button pButton class="p-button-text" (click)="packageSourceMenuPopup.toggle($event)">
                          <fa-icon icon="ellipsis-v"></fa-icon>
                        </button>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @if (interactive) {
              <div class="reupload-button">
                @if (userMayUploadPackages) {
                  <p-button class="custom-label" title="Manually uploading a new version does not disconnect the package source from the package." color="accent" label="Upload New Version" (click)="openReuploadDialog($event);"
                    data-testing-id="mobileapps-upload-new-app-btn">
                    <fa-icon icon="upload"></fa-icon>
                  </p-button>
                }
              </div>
            }
          </div>
        }
        <div class="form-section">
          <label>App Variants</label>
          <div class="variants">
            @if (entity.origBlobId; as pkgId) {
              <div class="original variant" data-testing-id="original-package-version">
                <span class="name">Original App</span>
                <div class="variant-info">
                  <div class="filetype info-item"><label>Type</label>{{entity.origPackageType}}</div>
                  @if (entity.origMetaData?.fileSize) {
                    <div class="filesize info-item">
                      <label>Size</label>{{convertBytesToSuitableUnitsString(entity.origMetaData?.fileSize)}}
                    </div>
                  }
                </div>
                <div class="shifter" style="flex: 1 1 0;"></div>
                <button pButton class="p-button-text" [label]="variantCallbacks.regularActionName" (click)="variantCallbacks.regularCallback(entity)" data-testing-id="install-original-package-btn">
                </button>
              </div>
            }
            @if (entity.instrumentedBlobId) {
              <div class="instrumented variant" data-testing-id="instrumented-package-version">
                <span class="name">Instrumented App</span>
                <div class="variant-info">
                  <div class="filetype info-item"><label>Type</label>{{entity.instrumentedPackageType}}</div>
                  @if (entity.instrumentedMetaData?.fileSize) {
                    <div class="filesize info-item">
                      <label>Size</label>{{convertBytesToSuitableUnitsString(entity.instrumentedMetaData?.fileSize)}}
                    </div>
                  }
                </div>
                <div class="middle-area">
                  @if (entity.instrumentedMetaData?.instrumentation?.status === "ongoing") {
                    <div class="instrumentation-feedback">
                      <span>Instrumenting</span>
                      <p-progressSpinner class="uploading-spinner" strokeWidth="6"></p-progressSpinner>
                    </div>
                  } @else if (entity.instrumentedMetaData?.instrumentation?.status === "failed") {
                    <div class="instrumentation-feedback">
                      <span class="failed" pTooltip="Try uploading again" tooltipPosition="top">Instrumentation failed</span>
                    </div>
                  }
                </div>
                <button pButton class="p-button-text" [disabled]="entity.instrumentedMetaData?.instrumentation?.status != 'finished'" [label]="variantCallbacks.instrumentedActionName" (click)="variantCallbacks.instrumentedCallback(entity)" data-testing-id="install-instrumented-package-btn"></button>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
  <p-dialog [dismissableMask]="true" [(visible)]="webhookDialogVisible" [showHeader]="false" [closeOnEscape]="true" [closable]="true" [modal]="true" [baseZIndex]="1100" [draggable]="false" class="webhook-modal" [resizable]="false">
    <div class="container">
      <div class="explanation">
        Configure this webhook in App Center to trigger a package update.
        <fa-icon icon="question-circle" tooltipZIndex="3000" pTooltip="You can enter this webhook URL in the Webhooks menu of your App Center app settings."></fa-icon>
      </div>
      <div class="webhook-field">
        <span class="url">{{makeWebhookUrl(entity?.packageSource?.webhook) || "No Webhook available" }}</span>
        <fa-icon size="lg" pTooltip="Copy to clipboard" tooltipPosition="right" icon="copy" class="copy-button" (click)="copyToClipboard(makeWebhookUrl(entity?.packageSource?.webhook))"></fa-icon>
      </div>
    </div>
  </p-dialog>

  <p-dialog [dismissableMask]="true" [(visible)]="releaseChooserVisible" [showHeader]="false" [closeOnEscape]="true" [closable]="true" [modal]="true" [baseZIndex]="1100" [draggable]="false" class="releasechooser-modal" [resizable]="false">
    <div class="releaserchoose-container">
      <div class="explanation">Select release.
        <fa-icon icon="question-circle" tooltipZIndex="10000" pTooltip="The selected release will be downloaded and made active for this package source."></fa-icon>
      </div>

      <div class="releases">
        @if (!releases) {
          <div class="wm-spinner-centered">
            <p-progressSpinner></p-progressSpinner>
            <div class="wm-spinnerlabel">Loading...</div>
          </div>
        }
        @if (!!releases) {
          <p-select [options]="releases" [filter]="true" [autoDisplayFirst]="true" filterBy="label" [(ngModel)]="chosenRelease"></p-select>
        }
      </div>
      @if (!packageSourceUpdating) {
        <button [disabled]="!chosenRelease" (click)="updatePackageFromPackageSource(entity.id, chosenRelease); $event.stopPropagation();" pButton type="button" label="Get Release" class="ui-button-raised">
          <fa-icon icon="thumbtack"></fa-icon>
        </button>
      }
      @if (packageSourceUpdating) {
        <button pButton type="button" label="Get Release" class="ui-button-raised">
          <fa-icon icon="sync-alt" animation="spin" [fixedWidth]="true"></fa-icon>
        </button>
      }
    </div>
  </p-dialog>
